function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import "./ItemListItem.css";
import Log from '@deephaven/log';
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('ItemListItem');
class ItemListItem extends Component {
  static handleKeyDown() {
    log.log('ItemListItem.handleKeyDown false');
    return false;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "itemRef", void 0);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.itemRef = /*#__PURE__*/React.createRef();
  }
  handleBlur(e) {
    var _this$props = this.props,
      itemIndex = _this$props.itemIndex,
      onBlur = _this$props.onBlur;
    onBlur(itemIndex, e);
  }
  handleFocus(e) {
    var _this$props2 = this.props,
      itemIndex = _this$props2.itemIndex,
      onFocus = _this$props2.onFocus;
    onFocus(itemIndex, e);
  }
  handleClick(e) {
    var _this$props3 = this.props,
      itemIndex = _this$props3.itemIndex,
      onClick = _this$props3.onClick;
    onClick(itemIndex, e);
  }
  handleContextMenu(e) {
    var _this$props4 = this.props,
      itemIndex = _this$props4.itemIndex,
      onContextMenu = _this$props4.onContextMenu;
    onContextMenu(itemIndex, e);
  }
  handleDragStart(e) {
    var _this$props5 = this.props,
      itemIndex = _this$props5.itemIndex,
      onDragStart = _this$props5.onDragStart;
    onDragStart(itemIndex, e);
  }
  handleDrag(e) {
    var _this$props6 = this.props,
      itemIndex = _this$props6.itemIndex,
      onDrag = _this$props6.onDrag;
    onDrag(itemIndex, e);
  }
  handleDragOver(e) {
    // Have to call preventDefault otherwise onDrop won't get triggered
    e.preventDefault();
    var _this$props7 = this.props,
      itemIndex = _this$props7.itemIndex,
      onDragOver = _this$props7.onDragOver;
    onDragOver(itemIndex, e);
  }
  handleDragEnd(e) {
    var _this$props8 = this.props,
      itemIndex = _this$props8.itemIndex,
      onDragEnd = _this$props8.onDragEnd;
    onDragEnd(itemIndex, e);
  }
  handleDrop(e) {
    var _this$props9 = this.props,
      itemIndex = _this$props9.itemIndex,
      onDrop = _this$props9.onDrop;
    onDrop(itemIndex, e);
  }
  handleDoubleClick(e) {
    var _this$props0 = this.props,
      itemIndex = _this$props0.itemIndex,
      onDoubleClick = _this$props0.onDoubleClick;
    onDoubleClick(itemIndex, e);
  }
  handleMouseMove(e) {
    var _this$props1 = this.props,
      itemIndex = _this$props1.itemIndex,
      onMouseMove = _this$props1.onMouseMove;
    onMouseMove(itemIndex, e);
  }
  handleMouseDown(e) {
    var _this$props10 = this.props,
      itemIndex = _this$props10.itemIndex,
      onMouseDown = _this$props10.onMouseDown;
    onMouseDown(itemIndex, e);
  }
  handleMouseUp(e) {
    var _this$props11 = this.props,
      itemIndex = _this$props11.itemIndex,
      onMouseUp = _this$props11.onMouseUp;
    onMouseUp(itemIndex, e);
  }
  render() {
    var _this$props12 = this.props,
      isDraggable = _this$props12.isDraggable,
      isFocused = _this$props12.isFocused,
      isSelected = _this$props12.isSelected,
      style = _this$props12.style,
      children = _this$props12.children,
      dataTestId = _this$props12['data-testid'];
    return /*#__PURE__*/_jsx("div", {
      className: classNames('item-list-item', {
        active: isSelected
      }, {
        'is-focused': isFocused
      }, {
        'is-draggable': isDraggable
      }),
      onKeyDown: ItemListItem.handleKeyDown,
      onContextMenuCapture: this.handleContextMenu,
      onClick: this.handleClick,
      onDrag: this.handleDrag,
      onDragStart: this.handleDragStart,
      onDragOver: this.handleDragOver,
      onDragEnd: this.handleDragEnd,
      onDrop: this.handleDrop,
      onDoubleClick: this.handleDoubleClick,
      onMouseDown: this.handleMouseDown,
      onMouseMove: this.handleMouseMove,
      onMouseUp: this.handleMouseUp,
      tabIndex: -1,
      ref: this.itemRef,
      role: "listitem",
      style: style,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      draggable: isDraggable,
      "data-testid": dataTestId,
      children: children
    });
  }
}
_defineProperty(ItemListItem, "defaultProps", {
  children: null,
  isDraggable: false,
  isFocused: false,
  isSelected: false,
  itemIndex: 0,
  'data-testid': undefined,
  onBlur() {
    // no-op
  },
  onClick() {
    // no-op
  },
  onContextMenu() {
    // no-op
  },
  onDragStart() {
    // no-op
  },
  onDrag() {
    // no-op
  },
  onDragOver() {
    // no-op
  },
  onDragEnd() {
    // no-op
  },
  onDrop() {
    // no-op
  },
  onDoubleClick() {
    // no-op
  },
  onFocus() {
    // no-op
  },
  onMouseDown() {
    // no-op
  },
  onMouseMove() {
    // no-op
  },
  onMouseUp() {
    // no-op
  },
  style: {}
});
export default ItemListItem;
//# sourceMappingURL=ItemListItem.js.map